import { Typography, Avatar } from "antd";
import styles from "./AmznAnalisys.module.css";

const { Text } = Typography;

// Интерфейс для элемента анализа
interface AnalysisItem {
  id: string;
  title: string;
  author: {
    name: string;
    avatar: string;
  };
  recommendation: "Buy" | "Strong Buy" | "Hold" | "Sell";
  category: string;
  date: string;
  comments: number;
}

// Стили для компонента

// Данные для анализа AMZN
const analysisData: AnalysisItem[] = [
  {
    id: "1",
    title: "eBay: Unmissable Offers This Week",
    author: {
      name: "Koray Okumus",
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face",
    },
    recommendation: "Buy",
    category: "Market Insights",
    date: "Sun, June 01",
    comments: 8,
  },
  {
    id: "2",
    title: "Walmart: Deals You Can't Ignore",
    author: {
      name: "Lana Steiner",
      avatar:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=40&h=40&fit=crop&crop=face",
    },
    recommendation: "Strong Buy",
    category: "Retail Trends",
    date: "Mon, June 02",
    comments: 15,
  },
  {
    id: "3",
    title: "Target: Special Discounts Just Launched",
    author: {
      name: "Olivia Rhye",
      avatar:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&h=40&fit=crop&crop=face",
    },
    recommendation: "Hold",
    category: "Consumer News",
    date: "Tue, June 03",
    comments: 10,
  },
  {
    id: "4",
    title:
      "Amazon: The Whole Package, Long-Term Buy For This Tough Grader (Upgrade)",
    author: {
      name: "Demi Wilkinson",
      avatar:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&h=40&fit=crop&crop=face",
    },
    recommendation: "Buy",
    category: "Tech Review",
    date: "Wed, June 04",
    comments: 5,
  },
  {
    id: "5",
    title: "Alibaba: Exclusive Shopping Events",
    author: {
      name: "Kate Morrison",
      avatar:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=40&h=40&fit=crop&crop=face",
    },
    recommendation: "Buy",
    category: "Global Market",
    date: "Thu, June 05",
    comments: 20,
  },
  {
    id: "6",
    title: "Newegg: Hot Tech Deals This Month",
    author: {
      name: "Kari Rasmussen",
      avatar:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=40&h=40&fit=crop&crop=face",
    },
    recommendation: "Buy",
    category: "Gadget Guide",
    date: "Fri, June 06",
    comments: 12,
  },
];

// Компонент для бейджа рекомендации
const RecommendationBadge = ({
  recommendation,
}: {
  recommendation: AnalysisItem["recommendation"];
}) => {

  const getBadgeClass = () => {
    switch (recommendation) {
      case "Buy":
        return styles.badgeBuy;
      case "Strong Buy":
        return styles.badgeStrongBuy;
      case "Hold":
        return styles.badgeHold;
      case "Sell":
        return styles.badgeSell;
      default:
        return styles.badgeBuy;
    }
  };

  return (
    <div className={`${styles.badge} ${getBadgeClass()}`}>
      {recommendation}
    </div>
  );
};

export const AmznAnalisys = () => {

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>AMZN Analysis</h3>
        <div className={styles.divider} />
      </div>

      <div className={styles.table}>
        {analysisData.map((item) => (
          <div key={item.id} className={styles.tableItem}>
            <Avatar
              size={40}
              src={item.author.avatar}
              className={styles.avatar}
            />
            <div className={styles.content}>
              <h4 className={styles.itemTitle}>{item.title}</h4>
              <div className={styles.metaInfo}>
                <RecommendationBadge recommendation={item.recommendation} />
                <Text className={styles.category}>{item.category}</Text>
                <Text className={styles.separator}>·</Text>
                <Text className={styles.date}>{item.date}</Text>
                <Text className={styles.separator}>·</Text>
                <Text className={styles.comments}>
                  {item.comments} Comments
                </Text>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <div className={styles.viewAllButton}>View all</div>
      </div>
    </div>
  );
};
